var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-justify"},[_c('app-tab',{ref:"horizontalTabRef",attrs:{"tabs":_vm.tabs,"type":"horizontal","elevated":false,"tabClass":"px-4 py-3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }